import { defineEvent } from '../types/event';
export var COUPON_MODAL_MICRO_YES_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        },
        {
            name: 'Heap',
            alias: 'coupon-modal_yes-click'
        }
    ]
});
